import { styled } from '@mui/material';

const Banner = styled('section')(({ theme }) => ({
    background: 'linear-gradient(135deg, #e7e8fd 0%, #f5e9f7 100%)',
    borderRadius: theme.shape.borderRadiusLg,
    border: `1px solid ${ theme.palette.divider }`,
    overflow: 'hidden'
}));

export default Banner;
